import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UserGroupSubscriptionMaintenanceComponent } from './page/user-group-subscription-maintenance/user-group-subscription-maintenance.component';
import { TermsMaintenanceComponent } from '../setting/pages/terms-maintenance/terms-maintenance.component';
import { AuthGuard } from 'src/app/core/guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    canActivateChild: [AuthGuard],
    children:[
      {
        path: 'UserGroupSubscriptionMaintenance',
        component: UserGroupSubscriptionMaintenanceComponent
      },
      {
        path: 'TermsMaintenance',
        component: TermsMaintenanceComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SystemSettingRoutingModule { }
